import { gql } from '@apollo/client';

export const GetMySitesQueryName = 'GetMySites';

export const GET_MY_SITES_QUERY = gql`
  query ${GetMySitesQueryName} {
    getMySites {
      id
      amcrProjectIds
      image
      images
      createdAt
      createdBy
      createdByName
      createdByEmail
      description
      eraId
      localName
      name
      longitude
      latitude
      shared
      canAddFinds
      siteType
      visibility
      updatedAt
    }
  }
`;
